module.exports = __webpack_public_path__ + "img/ic_qmarker_asset_lbl_issue.68b0ce91.png";